import Cookies from 'js-cookie';

export default function() {
  const newsletterEmail = document.getElementById('newsletter-email');
  const newsletterSubmit = document.querySelector('.js-newsletter-submit');
  const newsletterForm = document.getElementById('subscribe-form');

  if (newsletterSubmit) {
    newsletterSubmit.addEventListener('click', () => {
      Cookies.set('cookie-email', newsletterEmail.value, { expires: 365 });
    });
  }
}
